var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 220,
    viewBox: "0 0 213 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.282 175.771C163.302 165.38 154.193 127.516 129.936 91.1995C105.679 54.8828 75.46 33.8657 62.4397 44.2563C49.4193 54.647 58.5285 92.5108 82.7855 128.827C107.042 165.144 137.262 186.161 150.282 175.771Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.722 140.549C151.199 134.487 184.583 115.888 183.288 99.0069C181.993 82.126 146.508 73.3555 104.031 79.4174C61.5542 85.4794 28.17 104.078 29.4654 120.959C30.7609 137.84 66.2453 146.611 108.722 140.549Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3901 186.738C87.7058 193.229 114.081 164.136 132.301 121.757C150.521 79.3784 153.686 39.7624 139.37 33.2721C125.054 26.7819 98.6791 55.8751 80.4591 98.2537C62.2392 140.632 59.0743 180.248 73.3901 186.738Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.9 120.425C107.132 122.797 113.379 120.055 115.853 114.3C118.328 108.545 116.092 101.957 110.86 99.5851C105.627 97.213 99.38 99.9553 96.9058 105.71C94.4316 111.465 96.6674 118.053 101.9 120.425Z",
    fill: "#80FFAF",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftAtom1);
export default __webpack_public_path__ + "static/media/gift-atom-1.59ae7a41b13e7fa6bbce93efc8bae2e5.svg";
export { ForwardRef as ReactComponent };